import {createFileRoute} from '@tanstack/react-router';

import {parseNonEmpty, parsePage} from '@/lib/search-params';
import {ProjectsListPage} from '@/modules/projects/pages/ProjectsListPage';

/**
 * URL state for the projects index. All fields optional so links from
 * elsewhere can land here bare; the page reads defaults (`page ?? 1`).
 * `contract` is a raw `contract_type` string; absent means all.
 */
export interface ProjectsListSearch {
  client?: string;
  /** `ProjectType` id from the configurable lookup (DERP-156). */
  type?: string;
  /** Exact `contract_type` match. */
  contract?: string;
  q?: string;
  page?: number;
}

const validateProjectsListSearch = (search: Record<string, unknown>): ProjectsListSearch => ({
  client: parseNonEmpty(search.client),
  // Not validated against the lookup — it's admin-configurable, so the valid
  // set isn't known here. An unknown id simply matches nothing.
  type: parseNonEmpty(search.type),
  // Not validated against the vocabulary: legacy rows hold arbitrary
  // strings, so any value is potentially a real match.
  contract: parseNonEmpty(search.contract),
  q: parseNonEmpty(search.q),
  page: parsePage(search.page),
});

export const Route = createFileRoute('/_authenticated/projects/')({
  validateSearch: validateProjectsListSearch,
  component: ProjectsListPage,
});
